"use client";

import { useEffect, useRef } from "react";

export function useInfiniteScrollSentinel({
  enabled,
  canLoadMore,
  onLoadMore,
}: {
  enabled: boolean;
  canLoadMore?: boolean;
  onLoadMore?: () => void;
}) {
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!enabled || !onLoadMore) return;
    const sentinel = sentinelRef.current;
    if (!sentinel) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && canLoadMore) onLoadMore();
      },
      { rootMargin: "200px" },
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [enabled, canLoadMore, onLoadMore]);

  return sentinelRef;
}
